import React from 'react';
import './qualification.css';


const Qualification = () => {
  const [toggleState, setToggleState] = React.useState(1);
    const toggleTab = (index) => {
        setToggleState(index);     
    }
  return (
    <section className="qualification__section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My Personal Journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          
          <div className={toggleState === 1 ?"qualification__button qualification__active button--flex": "qualification__button button--flex"} onClick={()=>toggleTab(1)}>
            <i  className='uil uil-graduation-cap qualification__icon'></i>Education
          </div>

          <div className={toggleState === 2 ?"qualification__button qualification__active button--flex": "qualification__button button--flex"} onClick={()=>toggleTab(2)}>
            <i  className='uil uil-briefcase-alt qualification__icon'></i>Experience
          </div>

        </div>


        <div className="qualification__sections">
          <div className={toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">MS in Informatics</h3>
                <span className="qualification__subtitle">Northeastern University, Toronto</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2023 -  2025

                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

            </div>

            <div className="qualification__data">
              <div></div> 
              
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">B-Tech in ECE</h3>
                <span className="qualification__subtitle">University of Kerala</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2014 -  2018

                </div>
              </div>

              
            </div>

            {/* <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Web Development</h3>
                <span className="qualification__subtitle">University of Kerala</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2013 -  2014

                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

            </div>

            <div className="qualification__data">
              <div></div> 
              
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">Ux Designer</h3>
                <span className="qualification__subtitle">University of Kerala</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2021 -  2022

                </div>
              </div>

              
            </div> */}


          </div>

          <div className={toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}>
            
          <div className="qualification__data">
              <div></div> 
              
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">IT/AV Support Assistant</h3>
                <span className="qualification__subtitle">Northeastern University, Toronto</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2024 -  2025

                </div>
              </div>

              
            </div>
            
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Senior Software Engineer</h3>
                <span className="qualification__subtitle">InApp Information Technologies Pvt Ltd</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2021 -  2023

                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

            </div>

            <div className="qualification__data">
              <div></div> 
              
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">Project Coordinator</h3>
                <span className="qualification__subtitle">InApp Information Technologies Pvt Ltd</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2021 -  2023 

                </div>
              </div>

              
            </div>

            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Software Engineer</h3>
                <span className="qualification__subtitle">InApp Information Technologies Pvt Ltd</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2019 -  2021

                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

            </div>

            <div className="qualification__data">
              <div></div> 
              
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">Business Development Executive</h3>
                <span className="qualification__subtitle">InApp Information Technologies Pvt Ltd</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2018 -  2019

                </div>
              </div>

              
            </div>


            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Business Development Executive</h3>
                <span className="qualification__subtitle">Yarab Technologies Pvt Ltd</span>
                <div className='qualification__calender'>
                  <i className="uil uil-calendar-alt"></i> 2018 -  2018

                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

            </div>

            


          </div>

        </div>
      </div>

    </section>
  )
}

export default Qualification